const MarqueeHeading = ({ marqueeTitle, smallTitle, paragraph }) => (
  <>
    <div className="overflow-hidden">
      <p className="inline-block overflow-hidden font-bold text-[141px] md:text-[312px] bg-gradient-roaddy-marquee-text bg-clip-text text-transparent animate-right-to-left text-nowrap">
        <span className="font-gilroy">{marqueeTitle}</span>
      </p>
    </div>
    <div className="relative -mt-48">
      <h2 className="text-white font-bold text-6xl md:pl-8 xl:pl-48 -mt-48 z-0">
        <span className="font-gilroy">{smallTitle}</span>
      </h2>
      <div className="px-48 md:px-8 xl:px-48">
        <p className="text-white text-justify md:text-start mt-0 md:mt-12 text-2xl md:pt-8 xl:pt-0">
          <span className="font-gilroy">{paragraph}</span>
        </p>
      </div>
    </div>
  </>
);
export default MarqueeHeading;
